/*
 * Corner Boxe · comportements communs aux sections cb-*
 * - liens d'ancre (#diag, #guide-tailles…) : défilement doux vers la section ciblée sur la même page,
 *   en tenant compte du header collant ; ouvre la question de FAQ ciblée si c'est un <details>.
 */
(() => {
  if (window.cbBaseLoaded) return;
  window.cbBaseLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.cb a[href^="#"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey) return;

    const id = decodeURIComponent(link.getAttribute('href').slice(1));
    const target = id && document.getElementById(id);
    if (!target) return;

    event.preventDefault();

    if (target.tagName === 'DETAILS') target.open = true;

    target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });

    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });

    history.pushState(null, '', `#${id}`);
  }, { capture: true }); // avant le défilement d'ancre d'Impact (écouteur sur <html>), qui n'ouvrirait pas la question
})();
